(() => {
  'use strict';
  // Quick-add sheet (home, collections, "Completa el look"): open on a colour that has
  // stock in Shopify and mark colours without stock, like the product page does.
  // "Últimas piezas": a small tag next to the colour name (product page and quick add) when every
  // available size of the selected colour has 1–2 units left (data from assh-low-stock.liquid).
  const norm=s=>String(s||'').normalize('NFD').replace(/[̀-ͯ]/g,'').toLowerCase();
  const realName=c=>({'Essential Black':'Negro','Tinto':'Vino','Azul Océano':'Azul Oceano'}[c]||c);
  const triggers='[data-v41-quick],.category-quick-v40,.quick,.pdp-look-quick-v43';
  const isLowColor=(slug,label)=>((window.ASSHLowColors||{})[window.ASSHShop?.handles?.[slug]]||[]).some(c=>norm(c)===norm(realName(label)));

  // Shows or hides the tag right after the element that holds the colour name.
  function colorTag(nameEl,slug){
    if(!nameEl)return;
    let tag=nameEl.parentElement.querySelector(':scope > .assh-low-tag');
    if(!tag){tag=document.createElement('span');tag.className='assh-low-tag';tag.textContent='Últimas piezas';nameEl.before(tag);}
    tag.hidden=!isLowColor(slug,nameEl.textContent.trim());
  }

  function fix(){
    const sheet=document.querySelector('.quick-sheet-v47'),p=window.ASSHCommerce?.products?.[sheet?.dataset.shopSlug];
    if(!sheet||!p)return;
    const ci=(p.options||[]).map(o=>typeof o==='string'?o:o.name).findIndex(n=>/color/i.test(n));
    const hasStock=label=>p.variants.some(v=>v.available&&norm(v.options?.[ci])===norm(realName(label)));
    const swatches=[...sheet.querySelectorAll('[data-v47-qcolor]')];
    for(const button of swatches){
      const label=button.dataset.v47Qcolor,soldOut=!hasStock(label);
      button.classList.toggle('is-sold-out',soldOut);
      if(soldOut)button.title=label+' · Agotado';else button.removeAttribute('title');
    }
    const active=swatches.find(b=>b.classList.contains('is-active'));
    if(active&&!hasStock(active.dataset.v47Qcolor))swatches.find(b=>hasStock(b.dataset.v47Qcolor))?.click();
    setTimeout(()=>colorTag(sheet.querySelector('[data-v47-qcolorname]'),sheet.dataset.shopSlug),0);
  }

  function pdpTag(){
    const slug=window.ASSHShop?.currentSlug,nameEl=document.querySelector('[data-pdp-color-name]');
    if(!slug||!nameEl)return;
    const sync=()=>colorTag(nameEl,slug);
    new MutationObserver(sync).observe(nameEl,{childList:true,characterData:true,subtree:true});
    sync();
  }

  // Capture phase: the theme stops propagation on its quick-add buttons.
  document.addEventListener('click',e=>{
    if(e.target.closest(triggers)){setTimeout(fix,60);setTimeout(fix,400);}
    const sheet=e.target.closest('.quick-sheet-v47');
    if(sheet&&e.target.closest('[data-v47-qcolor]'))setTimeout(()=>colorTag(sheet.querySelector('[data-v47-qcolorname]'),sheet.dataset.shopSlug),0);
  },true);
  new MutationObserver(()=>{if(document.body.classList.contains('quick-open-v47'))setTimeout(fix,60);}).observe(document.body,{attributes:true,attributeFilter:['class']});

  const style=document.createElement('style');
  style.textContent='.quick-sheet-v47 [data-v47-qcolor].is-sold-out{opacity:.38}'
    +'.assh-low-tag{display:inline-flex;align-items:center;gap:6px;margin:0 10px 0 auto;color:#7b344a;font-weight:700;font-size:9px;letter-spacing:.14em;text-transform:uppercase;white-space:nowrap}'
    +'.assh-low-tag::before{content:"";width:6px;height:6px;border-radius:50%;background:#7b344a;animation:asshLowPulse 1.6s ease-in-out infinite}'
    +'.assh-low-tag[hidden]{display:none}'
    +'.quick-sheet-v47 .assh-low-tag{margin:0 8px 0 0}'
    +'@keyframes asshLowPulse{0%,100%{opacity:1}50%{opacity:.3}}'
    +'@media (prefers-reduced-motion:reduce){.assh-low-tag::before{animation:none}}';
  document.head.append(style);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>setTimeout(pdpTag,0));else setTimeout(pdpTag,0);
})();

// Product cards: the design picks a photo per card, but marks the first colour as selected, so a card
// could show a black top with "Azul Océano" ticked (and quick add opened in that colour). Mark the
// colour of the photo that is showing instead; quick add and the product link follow it.
(() => {
  const base=u=>String(u||'').split('?')[0].split('/').pop().toLowerCase();
  const slugify=s=>String(s||'').normalize('NFD').replace(/[̀-ͯ]/g,'').toLowerCase().replace(/[^a-z0-9]+/g,'-');
  const fileName=c=>({'Essential Black':'negro','Tinto':'vino'}[c]||slugify(c));
  function photoColour(card,swatches){
    const img=base(card.querySelector('img')?.getAttribute('src')),colours=window.ASSHCatalogV53?.[card.dataset.productSlug]?.colors||{};
    if(!img)return null;
    const fromCatalog=Object.keys(colours).find(c=>colours[c].some(u=>base(u)===img));
    if(fromCatalog)return fromCatalog;
    return swatches.map(b=>b.dataset.v54CardColor).find(c=>img.includes(fileName(c)))||null;
  }
  function sync(){
    for(const card of document.querySelectorAll('[data-product-slug]')){
      const swatches=[...card.querySelectorAll('.v54-card-swatch')];if(!swatches.length)continue;
      const colour=photoColour(card,swatches),active=swatches.find(b=>b.classList.contains('is-active'));
      if(!colour||active?.dataset.v54CardColor===colour||!swatches.some(b=>b.dataset.v54CardColor===colour))continue;
      swatches.forEach(b=>b.classList.toggle('is-active',b.dataset.v54CardColor===colour));
      card.dataset.v54ActiveColor=colour;
      for(const link of card.querySelectorAll('a[href*="/products/"]')){const u=new URL(link.href);u.searchParams.set('color',colour);link.setAttribute('href',u.pathname+u.search+u.hash);}
    }
  }
  let timer=0;const later=()=>{clearTimeout(timer);timer=setTimeout(sync,80);};
  const start=()=>{sync();addEventListener('load',sync);
    new MutationObserver(ms=>{if(ms.some(m=>[...m.addedNodes].some(n=>n.nodeType===1&&(n.matches('[data-product-slug]')||n.querySelector?.('.v54-card-swatch')))))later();}).observe(document.body,{childList:true,subtree:true});};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();
